import { useEffect } from 'react'

import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { useRecord } from '@/shared/hooks'
import { publicApiWithoutAuth } from '@/shared/lib/api'
import {
  isStorablePayload,
  shouldFetchPayload,
  VERSION_REFETCH_INTERVAL
} from '@/shared/lib/gamification-data/bootstrap'
import type { GamificationData} from '@/shared/store/gamificationDataStore';
import { useGamificationDataStore } from '@/shared/store/gamificationDataStore'


export const GamificationDataInitializer = () => {
  const { digitalProductId } = useDigitalProductContext()

  const { dataByProductId, setActiveDigitalProductId, setProductData } =
    useGamificationDataStore()


  const localVersion = dataByProductId[digitalProductId]?.version

  const { record: remoteVersion } = useRecord({
    r: `/user/digital_products/${digitalProductId}/gamification/version`,
    forceIdPresence: false,
    options: {
      retry: 10,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchInterval: VERSION_REFETCH_INTERVAL
    }
  }) as { record: { version: string | null } }

  // As duas decisões abaixo moram em `shared/lib/gamification-data/bootstrap`,
  // e são testadas lá: erradas, uma deixa o participante buscando um payload
  // que não existe e a outra apaga o conteúdo dele do store persistido.
  const shouldFetchData = shouldFetchPayload(
    digitalProductId,
    remoteVersion,
    localVersion
  )

  const { record: remoteData } = useRecord({
    r: `/user/digital_products/${digitalProductId}/gamification/data`,
    // Sem `guild_ids`: o payload não varia mais por participante — o recorte é
    // decisão de exibição do cliente. Isso também desacopla o bundle do
    // progresso, que antes precisava responder primeiro.
    params: { version: remoteVersion?.version },
    forceIdPresence: false,
    shouldFetch: shouldFetchData,
    queryFn: async ({ queryKey }) => {
      const { data } = await publicApiWithoutAuth.get(queryKey[0])

      return data
    }
  }) as { record: GamificationData }

  useEffect(() => {
    if (isStorablePayload(remoteData) && digitalProductId) {
      setProductData(digitalProductId, remoteData)
    }
  }, [remoteData, digitalProductId, setProductData])

  useEffect(() => {
    if (digitalProductId) {
      setActiveDigitalProductId(digitalProductId)
    }
  }, [digitalProductId])

  return null
}
